export default __webpack_public_path__ + "static/2581-28683807d3c8940529244e9e0f02ba73.jpeg";